/**
 * Centralized configuration for the Backoffice application
 * All environment variables should be accessed through this config object
 */

// Provider role types
export type ProviderRole = 'super_admin' | 'support' | 'readonly'

// Environment types
export type Environment = 'development' | 'production' | 'staging'

export const CONFIG = {
  version: "1.0.2a",

  // Environment Configuration
  environment: (import.meta.env.VITE_ENV || import.meta.env.MODE || 'development') as Environment,
  isDevelopment: import.meta.env.MODE === 'development' || import.meta.env.VITE_ENV === 'development',
  isProduction: import.meta.env.MODE === 'production' || import.meta.env.VITE_ENV === 'production',

  // Service Configuration
  service: {
    // baseUrl: import.meta.env.VITE_SERVICE_BASE_URL || "http://localhost:21000",
    // socketUrl: import.meta.env.VITE_SOCKET_URL || "http://localhost:21000",
    baseUrl: import.meta.env.VITE_SERVICE_BASE_URL || 'https://service.v2.salext.net',
    socketUrl: import.meta.env.VITE_SOCKET_URL || 'https://service.v2.salext.net'
  },

  // Authentication Configuration
  auth: {
    bypassAuth: import.meta.env.VITE_BYPASS_AUTH === 'true',
    adminUsers: import.meta.env.VITE_ADMIN_USERS || ''
  },

  // Provider Configuration (for external integrations)
  provider: {
    apiKey: import.meta.env.VITE_PROVIDER_API_KEY || '',
    secretKey: import.meta.env.VITE_PROVIDER_SECRET_KEY || '',
    role: (import.meta.env.VITE_PROVIDER_ROLE || 'readonly') as ProviderRole
  },

  // Feature Flags
  features: {
    // Add feature flags here as needed
    debugMode: import.meta.env.VITE_DEBUG === 'true'
  }
} as const

// Type for the config object
export type AppConfig = typeof CONFIG

// Helper function to validate configuration
export function validateConfig(): void {
  const warnings: string[] = []

  // Check for required configuration in production
  if (CONFIG.isProduction) {
    if (!CONFIG.provider.apiKey) {
      warnings.push('VITE_PROVIDER_API_KEY is not set')
    }
    if (!CONFIG.provider.secretKey) {
      warnings.push('VITE_PROVIDER_SECRET_KEY is not set')
    }
    if (CONFIG.auth.bypassAuth) {
      warnings.push('Auth bypass is enabled in production!')
    }
  }

  // Log warnings if any
  if (warnings.length > 0) {
    console.warn('Configuration warnings:', warnings)
  }
}

// Validate on initialization (development only)
if (CONFIG.isDevelopment) {
  validateConfig()
}
